var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.env === 'app')?_c('transition',{attrs:{"name":_vm.$tkHistory.transition}},[_c('tk-history',[_c('router-view')],1)],1):_c('router-view'),_vm._v(" "),_c('tk-global',{attrs:{"components":_vm.components}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bd3d318","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = o7K8
// module chunks = 10